import React from "react";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import TimeRegistrationDayCell from "./TimeRegistrationDayCell";
import "./TimeRegistrationDayTag.scss";

function weekdayFallbackBackground(day) {
	const d = moment(day).day();
	if (d === 0) return "#fce7f3";
	if (d === 6) return "#dcfce7";
	if (d === 5) return "#fef9c3";
	return "#ede9fe";
}

/**
 * Celda de día en fichajes: contenedor con estilos propios + TimeRegistrationDayCell;
 * tooltip si hay tipo de día de calendario.
 */
const TimeRegistrationDayTag = ({ time, dayType }) => {
	const hasType = dayType && Object.keys(dayType).length > 0;
	const backgroundColor = hasType
		? dayType.color
		: weekdayFallbackBackground(time);
	const label = moment(time).format("ddd");
	const dayNumber = moment(time).format("D");

	const cell = (
		<TimeRegistrationDayCell
			label={label}
			dayNumber={dayNumber}
			backgroundColor={backgroundColor}
		/>
	);

	const wrapperClass = [
		"time-registration-day-tag",
		hasType ? "time-registration-day-tag--has-tooltip" : "",
	]
		.filter(Boolean)
		.join(" ");

	if (hasType) {
		return (
			<OverlayTrigger
				placement="right"
				overlay={
					<Tooltip>
						{dayType.name} - {dayType.description}
					</Tooltip>
				}
			>
				<span className={wrapperClass}>{cell}</span>
			</OverlayTrigger>
		);
	}

	return <span className={wrapperClass}>{cell}</span>;
};

export default TimeRegistrationDayTag;
